import React from 'react'
import birdloading from '../../img/loading-stork.json'
import Lottie from 'lottie-react-web'

const Loading = () => {
    return (
        <>
        <div className="wrapper-desktop-loader d-mobile-hide">
            <div className="d-flex flex-column position-fixed w-100 h-100 text-center justify-content-center align-items-center">
                <Lottie width="25%" height options={{ animationData: birdloading }}/>
                <h5 className="h5-responsive font-weight-bold">
                    Don't go anywhere, this will only take a second.  
                </h5>        
            </div>
        </div>
        <div className="wrapper-mobile-loader d-mobile-show">
            <div className="d-flex flex-column position-fixed w-100 h-100 text-center justify-content-center align-items-center">
                <Lottie height="auto" width="75%" options={{ animationData: birdloading }}/>
                <h5 className="h5-responsive font-weight-bold px-5">
                    Don't go anywhere, this will only take a second.  
                </h5>        
            </div>
        </div>
        </>
    )
}

export default Loading
